<div class="header-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Navigation Section</h3>
    <button class="close-btn" (click)="onClose()" aria-label="Close panel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="segment-control">
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'content'"
        (click)="switchTab('content')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 6h12M3 10h12M3 14h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Content
      </button>
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'layout'"
        (click)="switchTab('layout')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="3" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    
    <!-- Media Section -->
    <app-section-accordion 
      title="Media"
      [isExpanded]="isSectionExpanded('media')"
      (toggle)="toggleSection('media')">
      
      <div class="accordion-content">
        <!-- Hidden file input (always available for replace functionality) -->
        <input 
          type="file" 
          id="logo-upload" 
          class="file-input" 
          accept="image/png,image/jpeg,image/jpg,image/gif,image/svg+xml,video/mp4"
          (change)="onFileSelected($event)"
          [disabled]="isUploadingLogo"
          style="display: none;">
        
        <!-- Logo Preview Section (when logo exists) -->
        <div class="logo-upload-wrapper" *ngIf="logoPreview">
          <!-- Logo Preview -->
          <div class="logo-preview-container">
            <div class="logo-preview-area">
              <img [src]="logoPreview" alt="Logo preview" class="logo-image" *ngIf="!isUploadingLogo">
              <div class="logo-loading" *ngIf="isUploadingLogo">
                <div class="loading-spinner"></div>
              </div>
            </div>
            
            <!-- Replace Button -->
            <button class="replace-button" (click)="onReplaceLogo()" [disabled]="isUploadingLogo">
              Replace
            </button>
            
            <!-- File Format Info -->
            <div class="file-info">
              <span class="file-info-text">Accepted formats - .png, .jpg, .jpeg, .mp4</span>
              <span class="file-info-divider">|</span>
              <span class="file-info-text">Max file size - 5MB</span>
            </div>
          </div>
          
          <div class="upload-error" *ngIf="uploadError">
            {{ uploadError }}
          </div>
        </div>

        <!-- Upload Area (when no logo exists) -->
        <div class="logo-upload-wrapper" *ngIf="!logoPreview">
          <div class="upload-area" 
               [class.disabled]="isUploadingLogo"
               (drop)="onDrop($event)" 
               (dragover)="onDragOver($event)">
            <label for="logo-upload" class="upload-label">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="upload-text">
                <span class="upload-link">Click to upload</span> or drag and drop
              </span>
              <span class="upload-hint">PNG, JPG, GIF, or SVG (max. 5MB)</span>
            </label>
          </div>
          
          <div class="upload-error" *ngIf="uploadError">
            {{ uploadError }}
          </div>
        </div>

        <!-- How should the image look dropdown -->
        <div class="form-group">
          <label class="form-label">How should the image look?</label>
          <select class="form-select">
            <option value="fill">Fill</option>
            <option value="fit">Fit</option>
            <option value="stretch">Stretch</option>
          </select>
        </div>
      </div>
    </app-section-accordion>

    <!-- Dynamic Page Sections -->
    <app-section-accordion 
      *ngFor="let navItem of getNavigationItems(); let i = index; trackBy: trackByIndex"
      [title]="navItem.label"
      [isExpanded]="isSectionExpanded('page_' + i)"
      (toggle)="toggleSection('page_' + i)">
      
      <div class="accordion-content">
        <div class="form-group">
          <label class="form-label">Page title*</label>
          <input 
            type="text" 
            class="form-input" 
            [class.error]="pageTitleErrors[i]"
            [(ngModel)]="navItem.label"
            (ngModelChange)="onNavigationChange(i, $event)"
            (input)="onPageTitleInput($event, i)"
            [maxlength]="MAX_PAGE_TITLE_LENGTH"
            placeholder="Home">
          <div class="error-message" *ngIf="pageTitleErrors[i]">
            {{ pageTitleErrors[i] }}
          </div>
          <div class="char-count" [class.warning]="(navItem.label?.length || 0) >= MAX_PAGE_TITLE_LENGTH - 3">
            {{ (navItem.label?.length || 0) }}/{{ MAX_PAGE_TITLE_LENGTH }}
          </div>
        </div>
        
        <!-- Information Banner -->
        <div class="info-banner">
          <div class="info-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="#3B82F6" stroke-width="1.5" fill="none"/>
              <path d="M10 14V10M10 6H10.01" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="info-content">
            <div class="info-title">Page titles are global!</div>
            <div class="info-description">
              Page titles will be same across all the instances they are used. i.e., in the navigation tabs, footer and also in the page settings.
            </div>
          </div>
        </div>
      </div>
    </app-section-accordion>

    <!-- Button Section -->
    <app-section-accordion 
      title="Button"
      [isExpanded]="isSectionExpanded('button')"
      (toggle)="toggleSection('button')">
      
      <div class="accordion-content" *ngIf="data.ctaButton">
        <div class="button-input-group">
          <label class="input-label">Add the button text here*</label>
          <div class="input-container">
            <input
              type="text"
              class="button-text-input"
              [(ngModel)]="data.ctaButton.text"
              (input)="onButtonTextChange($any($event.target).value)"
              placeholder="Book Wash">
          </div>
        </div>

        <div class="button-input-group">
          <label class="input-label">When clicked, go to page*</label>
          <div class="dropdown-container">
            <select
              class="navigation-dropdown"
              [ngModel]="data.ctaButton.buttonNavigation"
              (ngModelChange)="onButtonNavigationChange($event)">
              <option *ngFor="let option of buttonNavigationOptions; trackBy: trackByValue"
                      [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </app-section-accordion>

    <!-- Background Section -->
    <app-section-accordion 
      title="Background"
      [isExpanded]="isSectionExpanded('background')"
      (toggle)="toggleSection('background')">
      
      <div class="accordion-content">
        <div class="color-palette">
          <div class="color-list">
            <div class="color-item"
                 *ngFor="let color of predefinedColors; trackBy: trackByString"
                 [class.selected]="data.backgroundColor === color"
                 (click)="onBackgroundColorChange(color)">
              <div class="color-swatch" [style.background-color]="color"></div>
              <span class="color-code">{{ color }}</span>
              <div class="checkmark" *ngIf="data.backgroundColor === color">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          <div class="color-divider"></div>

          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <div class="color-item"
               *ngFor="let customColor of customColors; trackBy: trackByString"
               [class.selected]="data.backgroundColor === customColor"
               (click)="openColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </app-section-accordion>

  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="empty-state">
      <p>Layout options coming soon</p>
    </div>
  </div>

  <!-- Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="color-picker-content">
        <chrome-picker
          [(color)]="currentPickerColor"
          (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>
    </div>
  </div>
</div>

